import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { BtnFull } from '../Form/Button/style'
import { device } from 'components/Variable'

export const UploadPhotoStyle = styled.div`
	display: block;
	margin-bottom: ${rem(30)};

	@media (${device.mobileM}) {
		margin-bottom: 0;
	}
`
export const Body = styled.div`
	max-width: ${rem(468)};
	width: 100%;
	margin: 0 auto;
`
export const Previews = styled.div`
	display: flex;
	flex-flow: row wrap;
	margin: 0 ${rem(-4)};
	position: relative;
	overflow: hidden;
	& > div {
		padding: 0 ${rem(4)};
		margin-bottom: ${rem(8)};
	}

	${(p) =>
		p.isLoading &&
		css`
			min-height: ${rem(56)};
		`}

	${(p) =>
		p.isSingle &&
		css`
			justify-content: center;
		`}
	
	@media (${device.mobileL}) {
		justify-content: center;
	}
`
export const Preview = styled.div`
	max-width: ${rem(111)};
	height: ${rem(111)};
	margin: 0 auto;
	position: relative;
	border-radius: ${rem(8)};
	background-color: ${({ theme }) => theme.color.primary};
	&:hover {
		img {
			opacity: 0.3;
		}
		svg {
			opacity: 1;
		}
	}
	svg {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
		fill: ${({ theme }) => theme.color.blackOne};
		transition: opacity 0.3s;
		opacity: 0;
		cursor: pointer;
	}
	img {
		display: block;
		object-fit: cover;
		cursor: pointer;
		width: 100%;
		height: 100%;
		border-radius: ${rem(8)};
		transition: opacity 0.3s;
		opacity: 1;
	}
`
export const ButtonUpload = styled(BtnFull)`
	margin-bottom: ${rem(20)};
	input {
		position: absolute;
		visibility: hidden;
		left: 0;
		bottom: 0;
	}
`
